import * as Actions from './type';
import { searchCustomerAndVehicleApi } from '../../api/inspection/inspection-api';
import { GenerateImagePathForUser } from '../../utils/generate-temporary-image-path';

import axios from '../../api/index';

const baseURL = '/s3';

export const SearchCustomerAndVehicle = (req) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.SEARCH_REQUEST,
    });

    const { data } = await searchCustomerAndVehicleApi(req);

    dispatch({
      type: Actions.SEARCH_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.SEARCH_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const GetCustomerSignature = () => async (dispatch) => {
  try {
    const imagePath = GenerateImagePathForUser('signature.png');

    const result = await axios.get(
      `${baseURL}/getImageUrlForSignature?path=${imagePath}`,
    );

    dispatch({
      type: Actions.GET_CUSTOMER_SIGNATURE_SUCCESS,
      payload: result.data,
    });
  } catch (error) {
    return error;
  }
};
export const ClearSearchResults = () => async (dispatch) => {
  dispatch({ type: Actions.CLEAR_CUSTOMER_SEARCH_RESULTS });
};
